module.exports = __webpack_public_path__ + "static/media/thunderstorm.950e36a6.svg";